import lodash from 'lodash';
import {
    ALLOWED_SORTING_SYSTEM_PROPERTIES,
} from 'common/enums/folderSorting';

export const SET_SORTING_OPTIONS = 'SET_SORTING_OPTIONS';

export function setSortingOptions(folderId) {
    return (dispatch, getState) => {
        const storeState = getState();
        const binder = storeState.binder;
        if (!binder) {
            const sortOptions = _buildCustomSortOptions();
            return dispatch(writeSortingOptions(folderId, sortOptions));
        }
        const folders = lodash.get(binder, 'layout.folders', []);
        let folder;
        if (folderId) {
            folder = lodash.find(folders, f => f.id === folderId);
        } else {
            folder = lodash.find(folders, f => f.parentId === null);
        }
        const customSortOptions = lodash.get(folder, 'options.customSort', []);
        const descriptors = lodash.get(storeState, 'descriptors', []);
        const sortOptions = _buildCustomSortOptions(customSortOptions, descriptors);

        return dispatch(writeSortingOptions(folderId, sortOptions));
    };
}

export function writeSortingOptions(folderId, sortOptions) {
    return {
        type: SET_SORTING_OPTIONS,
        payload: {
            folderId,
            sortOptions
        }
    };
}

const _defaultSortingOptions = {
    sortBy: [{
        key: 'Default',
        value: 'default'
    }, {
        key: 'Uploaded Date',
        value: 'uploadDate'
    }, {
        key: 'Document Name',
        value: 'name'
    }, {
        key: 'Uploaded By',
        value: 'uploadUser.displayName'
    }, {
        key: 'Document Type',
        value: 'documentType.displayName'
    }],
    sortOrder: [{
        key: 'Ascending',
        value: 1
    }, {
        key: 'Descending',
        value: -1
    }]
};

const _buildCustomSortOptions = function (customSortingOptions, descriptors) {
    const sortOptions = [{ key: 'Default', value: 'default' }];

    if (lodash.isEmpty(customSortingOptions)) {
        return _defaultSortingOptions;
    }
    else {
        customSortingOptions.forEach(option => {
            const property = ALLOWED_SORTING_SYSTEM_PROPERTIES[option.subType];
            if (lodash.isNil(property)) {
                const descriptor = lodash.find(descriptors, d => d.id === option.subType);
                if (lodash.isNil(descriptor)) {
                    return;
                }
                sortOptions.push({
                    key: descriptor.displayName,
                    value: `descriptor.${option.subType}`,
                });
            }
            else {
                sortOptions.push({
                    key: property.name,
                    value: `system.${property.value}`,
                });
            }
        });
    }


    return {
        sortBy: sortOptions,
        sortOrder: [{
            key: 'Low to High',
            value: 1
        }, {
            key: 'High to Low',
            value: -1
        }]
    };
};